import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { ChartBarIcon, CalendarIcon, UserGroupIcon, ClockIcon } from '@heroicons/react/24/outline';
import { useProjectStore } from '../store/projectStore';
import { useNotificationStore } from '../store/notificationStore';

const mockMilestones = [
  { id: 1, name: 'Project Kickoff', status: 'Completed', date: '2023-08-01' },
  { id: 2, name: 'Requirements Gathering', status: 'Completed', date: '2023-08-15' },
  { id: 3, name: 'Architecture Design', status: 'In Progress', date: '2023-09-01' },
  { id: 4, name: 'Implementation Phase 1', status: 'Planned', date: '2023-09-15' },
];

export function ProjectDetail() {
  const { id } = useParams();
  const { selectedProject, setSelectedProject } = useProjectStore();
  const { addNotification } = useNotificationStore();
  
  React.useEffect(() => {
    if (id) {
      setSelectedProject(parseInt(id));
      
      // Simulate milestone completion after 2 seconds
      setTimeout(() => {
        addNotification({
          title: 'Milestone Completed',
          message: 'Requirements Gathering phase has been completed',
          type: 'success'
        });
      }, 2000);
    }
  }, [id, setSelectedProject]);

  if (!selectedProject) {
    return <Navigate to="/projects" replace />;
  }

  return (
    <div className="space-y-6">
      <div className="bg-gray-800 rounded-lg p-6">
        <h1 className="text-2xl font-bold text-white mb-2">{selectedProject.name}</h1>
        <p className="text-gray-400">{selectedProject.description}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="bg-gray-800 rounded-lg p-6">
          <div className="flex items-center mb-4">
            <CalendarIcon className="h-6 w-6 text-red-500 mr-2" />
            <h3 className="text-gray-400">Timeline</h3>
          </div>
          <p className="text-white">{selectedProject.startDate} to {selectedProject.endDate}</p>
        </div>

        <div className="bg-gray-800 rounded-lg p-6">
          <div className="flex items-center mb-4">
            <UserGroupIcon className="h-6 w-6 text-red-500 mr-2" />
            <h3 className="text-gray-400">Resources</h3>
          </div>
          <p className="text-white">{selectedProject.resourceCount} assigned</p>
        </div>

        <div className="bg-gray-800 rounded-lg p-6">
          <div className="flex items-center mb-4">
            <ClockIcon className="h-6 w-6 text-red-500 mr-2" />
            <h3 className="text-gray-400">Total Hours</h3>
          </div>
          <p className="text-white">{selectedProject.totalHours} hours</p>
        </div>

        <div className="bg-gray-800 rounded-lg p-6">
          <div className="flex items-center mb-4">
            <ChartBarIcon className="h-6 w-6 text-red-500 mr-2" />
            <h3 className="text-gray-400">Contract Type</h3>
          </div>
          <p className="text-white">{selectedProject.contractType}</p>
        </div>
      </div>

      <div className="bg-gray-800 rounded-lg p-6">
        <h2 className="text-xl font-semibold text-white mb-4">Milestones</h2>
        <div className="space-y-4">
          {mockMilestones.map((milestone) => (
            <div key={milestone.id} className="flex items-center justify-between p-4 bg-gray-750 rounded-lg">
              <div>
                <h3 className="text-white font-medium">{milestone.name}</h3>
                <p className="text-gray-400 text-sm">{milestone.date}</p>
              </div>
              <span className={`px-3 py-1 rounded-full text-sm font-medium
                ${milestone.status === 'Completed' ? 'bg-green-100 text-green-800' : 
                  milestone.status === 'In Progress' ? 'bg-blue-100 text-blue-800' : 
                  'bg-yellow-100 text-yellow-800'}`}>
                {milestone.status}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}